<template>
  <div class="terms-and-conditions">
    <div class="content">
      <section class="section">
        <div class="container">
          <section>

            <h1>Contact Us</h1><br>

            <p>
              We're here to help...
            </p>
            <p>
              If you need to contact us, the quickest way is to use the form below for a <strong>speedy</strong> reply from our customer support.
            </p>
            <p>
              <strong>Please Note:</strong> If your enquiry is regarding the status of your loan, please contact the lender directly.
            </p>
            <p>
              For frequently asked questions, please also refer to our FAQ.
            </p>

            <b-field horizontal label="From">
              <b-input name="name" placeholder="Name" expanded required></b-input>
              <b-input name="email" type="email" placeholder="Email" expanded required></b-input>
            </b-field>

            <b-field horizontal label="Message">
              <b-input type="textarea" required></b-input>
            </b-field>

            <b-field horizontal><!-- Label left empty for spacing -->
              <p class="control">
                <button class="button is-primary">
                  Send message
                </button>
              </p>
            </b-field>

          </section>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// import VueMarkdown from 'vue-markdown';
// import axios from 'axios';

export default {
  name: 'terms',
  components: {
    // VueMarkdown,
  },
  data() {
    return {
      pageContent: '',
    };
  },
  mounted() {

  },
  methods: {

  },
};

</script>


<style lang="scss">

</style>
